var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1733 14.8334H5.82665C2.55332 14.8334 1.15332 13.4334 1.15332 10.1601V10.0734C1.15332 7.11343 2.31999 5.68677 4.93332 5.4401C5.19999 5.4201 5.45332 5.6201 5.47999 5.89343C5.50665 6.16677 5.30665 6.41343 5.02665 6.4401C2.93332 6.63343 2.15332 7.6201 2.15332 10.0801V10.1668C2.15332 12.8801 3.11332 13.8401 5.82665 13.8401H10.1733C12.8867 13.8401 13.8467 12.8801 13.8467 10.1668V10.0801C13.8467 7.60677 13.0533 6.6201 10.92 6.4401C10.6467 6.41343 10.44 6.17343 10.4667 5.9001C10.4933 5.62677 10.7267 5.4201 11.0067 5.44677C13.66 5.67343 14.8467 7.10677 14.8467 10.0868V10.1734C14.8467 13.4334 13.4467 14.8334 10.1733 14.8334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 10.5C7.72667 10.5 7.5 10.2733 7.5 10V2.41333C7.5 2.14 7.72667 1.91333 8 1.91333C8.27333 1.91333 8.5 2.14 8.5 2.41333V10C8.5 10.2733 8.27333 10.5 8 10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.2336 4.39988C10.1069 4.39988 9.98022 4.35321 9.88022 4.25321L8.00022 2.37321L6.12022 4.25321C5.92689 4.44655 5.60689 4.44655 5.41355 4.25321C5.22022 4.05988 5.22022 3.73988 5.41355 3.54655L7.64689 1.31321C7.84022 1.11988 8.16022 1.11988 8.35355 1.31321L10.5869 3.54655C10.7802 3.73988 10.7802 4.05988 10.5869 4.25321C10.4936 4.35321 10.3602 4.39988 10.2336 4.39988Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.efe307c78cd59489d37e52a033090237.svg";
export { ForwardRef as ReactComponent };